module.exports = __webpack_public_path__ + "static/4-e126c58f9e4acc0cd8a668dd515f5960.png";